// Accessories
export const ADD_QUEUE_ACCESSORIES_COUNT = 'src/store/emarsys/ADD_QUEUE_ACCESSORIES_COUNT';
export const RESET_QUEUE_ACCESSORIES_COUNT = 'src/store/emarsys/RESET_QUEUE_ACCESSORIES_COUNT';

// New Car List
export const ADD_QUEUE_NCL_COUNT = 'src/store/emarsys/ADD_QUEUE_NCL_COUNT';
export const RESET_QUEUE_NCL_COUNT = 'src/store/emarsys/RESET_QUEUE_NCL_COUNT';

// New Car Purchase
export const ADD_QUEUE_NCP_COUNT = 'src/store/emarsys/ADD_QUEUE_NCP_COUNT';
export const RESET_QUEUE_NCP_COUNT = 'src/store/emarsys/RESET_QUEUE_NCP_COUNT';

// Promo
export const ADD_QUEUE_PROMO_COUNT = 'src/store/emarsys/ADD_QUEUE_PROMO_COUNT';
export const RESET_QUEUE_PROMO_COUNT = 'src/store/emarsys/RESET_QUEUE_PROMO_COUNT';

// Coupon Service
export const ADD_QUEUE_COUPON_SERVICE_COUNT = 'src/store/emarsys/ADD_QUEUE_COUPON_SERVICE_COUNT';
export const RESET_QUEUE_COUPON_SERVICE_COUNT =
  'src/store/emarsys/RESET_QUEUE_COUPON_SERVICE_COUNT';

// Package Service
export const ADD_QUEUE_PACKAGE_SERVICE_COUNT = 'src/store/emarsys/ADD_QUEUE_PACKAGE_SERVICE_COUNT';
export const RESET_QUEUE_PACKAGE_SERVICE_COUNT =
  'src/store/emarsys/RESET_QUEUE_PACKAGE_SERVICE_COUNT';

// Cart
export const ADD_QUEUE_CART_COUNT = 'src/store/emarsys/ADD_QUEUE_CART_COUNT';
export const RESET_QUEUE_CART_COUNT = 'src/store/emarsys/RESET_QUEUE_CART_COUNT';

// Global
export const ADD_QUEUE_GLOBAL_COUNT = 'src/store/emarsys/ADD_QUEUE_GLOBAL_COUNT';
export const RESET_QUEUE_GLOBAL_COUNT = 'src/store/emarsys/RESET_QUEUE_GLOBAL_COUNT';

// Product Knowledge List
export const ADD_QUEUE_PRODUCT_KNOWLEDGE_LIST_COUNT =
  'src/store/emarsys/ADD_QUEUE_PRODUCT_KNOWLEDGE_LIST_COUNT';
export const RESET_QUEUE_PRODUCT_KNOWLEDGE_LIST_COUNT =
  'src/store/emarsys/RESET_QUEUE_PRODUCT_KNOWLEDGE_LIST_COUNT';

// Product Knowledge
export const ADD_QUEUE_PRODUCT_KNOWLEDGE_COUNT =
  'src/store/emarsys/ADD_QUEUE_PRODUCT_KNOWLEDGE_COUNT';
export const RESET_QUEUE_PRODUCT_KNOWLEDGE_COUNT =
  'src/store/emarsys/RESET_QUEUE_PRODUCT_KNOWLEDGE_COUNT';

// Gamification
export const ADD_QUEUE_GAMIFICATION_COUNT = 'src/store/emarsys/ADD_QUEUE_GAMIFICATION_COUNT';
export const RESET_QUEUE_GAMIFICATION_COUNT = 'src/store/emarsys/RESET_QUEUE_GAMIFICATION_COUNT';
